import { render, staticRenderFns } from "./TabBody.vue?vue&type=template&id=431ce326&scoped=true"
import script from "./TabBody.vue?vue&type=script&lang=js"
export * from "./TabBody.vue?vue&type=script&lang=js"
import style0 from "./TabBody.vue?vue&type=style&index=0&id=431ce326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431ce326",
  null
  
)

export default component.exports